import { GetCurrentUser } from "./auth";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { FirestoreDB } from "./init";


export const logUserReportedError = async (error, userMessage) => {
    const userId = GetCurrentUser()?.uid;

    await addDoc(collection(FirestoreDB, 'errorReports'), {
        message: error.message || 'No message available',
        type: error.type || 'unknown',
        userAgent: navigator.userAgent,
        url: window.location.href,
        timestamp: serverTimestamp(),
        userId: userId || 'anonymous',
        additionalInfo: userMessage || '',
        stackTrace: error.stackTrace || 'Stack trace not available',
        severity: error.severity || 'medium',
        status: 'open'
    });
};